/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from 'react';

import { SelectField, TextField, EventField } from '@molecules';
import { useEvent } from '@api/hooks';
import { ROLE } from '@api/users/constants';

import Form from '../Form';

import { FORM_FIELDS } from './constants';

const isEventDisabled = (form) => form.getFieldValue(FORM_FIELDS.ROLE.name) !== ROLE.LOC_EDITOR;

const UserForm = React.forwardRef(({ data, onSubmit }, ref) => {
  const [form] = Form.useForm(FORM_FIELDS);
  const [disableEvent, setDisableEvent] = React.useState(true);

  const handleValuesChange = React.useCallback(() => {
    const disabled = isEventDisabled(form);
    setDisableEvent(disabled);
    if (disabled) {
      form.resetFields([FORM_FIELDS.EVENT.name]);
    }
  }, [form, setDisableEvent]);

  React.useEffect(() => {
    const formData = form.deserialize(data);
    form.resetFields();
    form.setFieldsValue(formData);
    handleValuesChange();
  }, [form, data, handleValuesChange]);

  const { event } = useEvent(data.eventId);

  React.useEffect(() => {
    form.setFieldsValue({ [FORM_FIELDS.EVENT.name]: event });
  }, [form, event]);

  React.useImperativeHandle(ref, () => form);

  return (
    <Form form={form} onSerializedFinish={onSubmit} layout="vertical" onValuesChange={handleValuesChange}>
      <TextField {...FORM_FIELDS.NAME} />
      <SelectField {...FORM_FIELDS.ROLE} />
      <EventField {...FORM_FIELDS.EVENT} disabled={disableEvent} />
    </Form>
  );
});

export default UserForm;
